import { render, staticRenderFns } from "./IndustryMatchedUsersGroup.vue?vue&type=template&id=3778b2e0&scoped=true"
import script from "./IndustryMatchedUsersGroup.vue?vue&type=script&lang=js"
export * from "./IndustryMatchedUsersGroup.vue?vue&type=script&lang=js"
import style0 from "./IndustryMatchedUsersGroup.vue?vue&type=style&index=0&id=3778b2e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3778b2e0",
  null
  
)

export default component.exports